import { createSlice } from '@reduxjs/toolkit'

import { IRewardPublicReducers, IRewardPublicState } from './reward-public.types'

const initialState: IRewardPublicState = {
  loading: false,
  error: '',
}

const { actions, reducer } = createSlice<IRewardPublicState, IRewardPublicReducers, 'reward-public'>({
  name: 'reward-public',
  initialState,
  reducers: {
    getPublicRewardDetailsByCodeRequest: (state) => {
      state.loading = true
      state.error = ''
    },
    getPublicRewardDetailsByCodeSuccess: (state, action) => {
      state.loading = false
      state.rewardPublicDetails = action.payload
    },
    getPublicRewardDetailsByCodeFailure: (state, action) => {
      state.loading = false
      state.error = action.payload.errorMessage
    },
    changeOrderInStock: (state, action) => {
      if (state?.rewardPublicDetails) {
        state.rewardPublicDetails.amount = action.payload.amount
      }
    },
  },
})

export { actions as RewardPublicActions }

export { reducer as rewardPublicReducer }
